import { useQuery } from "@tanstack/react-query";
import { useCompanyInfo } from "@/hooks/useCompanyInfo";
import { getOnboardingProgress } from "@/data/supabase/onboarding";
import { onboardingKeys } from "@/data/query-keys";
import { queryOptions } from "@/data/query-keys";

export function useOnboardingProgress() {
  const { data: companyData } = useCompanyInfo();
  const companyId = companyData?.id;

  const query = useQuery({
    queryKey: [...onboardingKeys.progress(), companyId ?? ""],
    queryFn: () => getOnboardingProgress(companyId!),
    enabled: !!companyId,
    staleTime: queryOptions.onboarding.staleTime,
    gcTime: queryOptions.onboarding.gcTime,
    refetchOnWindowFocus: true,
  });

  return {
    data: query.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    refetch: query.refetch,
  };
}
